import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useLocation } from '@reach/router';
import { extractLanguage } from '../../helpers/common';

export default function ContactFormComponent({ blok }) {
  const styles = clsx('blok-contact-form-component');

  const location = useLocation();

  const currentLanguage = extractLanguage(location.pathname);

  const formID = currentLanguage === 'en'
    ? '2VqRgXb5NURsG5zksxEn6QASTXm1FifV6J9zlfJsqmbB2o59ibPNHgLAR6W4EZLFN'
    : '1rq7nu1iuL8GqUg2CxYDsAd24yA6hpZHaH3VrPWMEc5Iu6PjKdqT5ddGThTRuS2n9';

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div className="pipedriveWebForms" id="contact-form">
        <iframe
          title="Pipedrive Web Forms"
          src={`https://webforms.pipedrive.com/f/${formID}?embeded=1&uuid=contact-form`}
          name={`${blok}-contact-form`}
          seamless="seamless"
        />
      </div>
    </div>
  );
}
